(() => {
  const node = document.querySelector('[data-anniversary-gift-config]');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const qualifying = new Set(config.productIds.map(String));
  const giftVariant = String(config.giftVariantId);
  const nativeFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  const marker = '_linear_anniversary_gift';
  let queue = Promise.resolve();
  let checkoutResuming = false;
  let refreshPricing = true;
  const active = () => config.eligibleCustomer && Date.now() >= Date.parse(config.startsAt) && Date.now() < Date.parse(config.endsAt);
  const qualifies = cart => active() && cart.items.some(item => qualifying.has(String(item.product_id)) && item.quantity > 0);
  function showError(message) {
    let box = document.getElementById('anniversary-gift-status');
    if (!message) { box?.remove(); return; }
    if (!box) {
      box = document.createElement('p');
      box.id = 'anniversary-gift-status';
      box.className = 'anniversary-gift-status';
      box.setAttribute('role', 'alert');
      const anchor = document.querySelector('.cart__footer-wrapper') || document.getElementById('MainContent');
      anchor?.prepend(box);
    }
    box.textContent = message;
  }
  async function request(endpoint, payload) {
    const response = await nativeFetch(root + endpoint, payload ? {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)} : {headers:{'Accept':'application/json'}});
    if (!response.ok) throw new Error(config.error);
    return response.json();
  }
  async function synchronize() {
    let cart = await request('cart.js');
    const previousTotal = cart.total_price;
    const managed = cart.items.filter(item => item.properties?.[marker] === '6-year-2026');
    const updates = {};
    let changed = false;
    if (!qualifies(cart)) {
      for (const item of managed) updates[item.key] = 0;
    } else {
      const filters = cart.items.filter(item => String(item.variant_id) === giftVariant && item.quantity > 0);
      if (!filters.length) {
        await request('cart/add.js', {items:[{id:config.giftVariantId,quantity:1,properties:{[marker]:'6-year-2026'}}]});
        changed = true;
      } else {
        const purchased = filters.some(item => item.properties?.[marker] !== '6-year-2026');
        managed.forEach((item,index) => {
          const quantity = purchased || index > 0 ? 0 : 1;
          if(item.quantity !== quantity) updates[item.key] = quantity;
        });
        if(refreshPricing && !Object.keys(updates).length) updates[filters[0].key] = filters[0].quantity;
      }
    }
    if (Object.keys(updates).length) {
      const quantityChanged = cart.items.some(item => item.key in updates && updates[item.key] !== item.quantity);
      cart = await request('cart/update.js',{updates});
      changed = quantityChanged || previousTotal !== cart.total_price;
    }
    else if (changed) cart = await request('cart.js');
    refreshPricing = false;
    showError(null);
    return {cart,changed};
  }
  function schedule() {
    const work = queue.catch(() => {}).then(synchronize);
    queue = work;
    return work.catch(error => { showError(config.error); throw error; });
  }
  async function freshSections(keys) {
    const response = await nativeFetch(`${window.location.pathname}?sections=${encodeURIComponent(keys.join(','))}`,{headers:{'Accept':'application/json'}});
    return response.ok ? response.json() : null;
  }
  window.fetch = async (input, options) => {
    const response = await nativeFetch(input, options);
    let url;
    try { url = new URL(typeof input === 'string' ? input : input.url, window.location.origin); } catch { return response; }
    const method = (options?.method || (typeof input === 'object' && input.method) || 'GET').toUpperCase();
    if(url.origin !== window.location.origin || method !== 'POST' || !/\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname) || !response.ok) return response;
    let data;
    try { data = await response.clone().json(); } catch { return response; }
    if(data.status && Number(data.status) >= 400) return response;
    try {
      const result = await schedule();
      if(result.changed) {
        const sections = data.sections ? await freshSections(Object.keys(data.sections)) : null;
        if(data.token && Array.isArray(data.items)) data = {...result.cart, ...(sections ? {sections} : {})};
        else if(sections) data.sections = sections;
        return new Response(JSON.stringify(data),{status:response.status,statusText:response.statusText,headers:response.headers});
      }
    } catch {}
    return response;
  };
  document.addEventListener('submit', async event => {
    if(checkoutResuming || event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.submitter;
    button.disabled = true;
    try {
      const result = await schedule();
      if(qualifies(result.cart) && !result.cart.items.some(item=>String(item.variant_id)===giftVariant)) throw new Error(config.error);
      checkoutResuming = true;
      button.disabled = false;
      event.target.requestSubmit(button);
    } catch { button.disabled = false; showError(config.error); }
  }, true);
  const initialSync = () => schedule().then(result => {
    if(result.changed && /\/cart\/?$/.test(window.location.pathname)) window.location.reload();
  }).catch(() => {});
  initialSync();
  window.addEventListener('pageshow',initialSync);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden) initialSync();});
  const remaining = Date.parse(config.endsAt) - Date.now();
  if(remaining > 0) setTimeout(initialSync,Math.min(remaining + 200,2147483647));
})();
